// extracted by mini-css-extract-plugin
module.exports = {"content":"content___1sL4f","title":"title___1sqbG","dek":"dek___1QXFj","featuredAuthor":"featuredAuthor___pKXeh"};